import type { PropsWithChildren } from "react";
import { useState } from "react";
import { styled } from "styled-components";

import { ExpandableContent, Image } from "common/components";
import type { CaseStudy } from "domains/caseStudy/types";
import { KnowledgeButtons } from "domains/publication/components/KnowledgeButtons";

const StyledListLink = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledDescriptionContainer = styled.div`
  padding-top: 10px;
  width: 100%;
  border-top: ${({ theme }) => theme.borders.normal};
`;

const StyledDescription = styled.div`
  margin: 0;
  line-height: 1.5rem;
`;

const StyledTextContent = styled.div`
  padding-top: 10px;
`;

const StyledPublicationImage = styled(Image)`
  float: right;
  width: 150px;
  margin: 0 0 10px 10px;
  height: 100px;
  border-radius: 5px;
`;

type WrapperProps = PropsWithChildren & { caseStudy: CaseStudy };

export const ExpandableCaseStudyItemWrapper = ({ caseStudy, children }: WrapperProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpansion = () => setIsExpanded(!isExpanded);
  const { images, summary, title } = caseStudy;

  return (
    <StyledListLink onClick={toggleExpansion}>
      {children}
      <ExpandableContent isActive={isExpanded}>
        <StyledTextContent>
          <StyledDescriptionContainer>
            {images && <StyledPublicationImage src={images.x_small} alt={title} />}
            <StyledDescription>{summary}</StyledDescription>
          </StyledDescriptionContainer>
          <KnowledgeButtons
            id={caseStudy.id}
            title={caseStudy.title}
            shareLink={caseStudy.link}
            link={caseStudy.link}
            variant="caseStudy"
            fullwidth
          />
        </StyledTextContent>
      </ExpandableContent>
    </StyledListLink>
  );
};
